import React from "react";
import { alpha, Box } from "@mui/material";

interface IconTileProps {
  children: React.ReactNode;
  color?: "primary" | "secondary";
  size?: number;
}

const IconTile: React.FC<IconTileProps> = ({ children, color = "primary", size = 48 }) => (
  <Box
    sx={{
      display: "grid",
      placeItems: "center",
      height: size,
      width: size,
      flexShrink: 0,
      borderRadius: 2,
      color: `${color}.main`,
      bgcolor: (t) => alpha(t.palette[color].main, 0.12),
      "& svg": { fontSize: size * 0.5 }
    }}
  >
    {children}
  </Box>
);

export default IconTile;
